import { createGlobalStyle } from 'styled-components'
import { ITheme } from './theme'

import dalekPinpoint from '../assets/fonts/DalekPinpointBold.ttf'

const GlobalStyle = createGlobalStyle<{ theme: ITheme }>`
  @font-face {
    font-family: "Dalek Pinpoint";
    src: url("${dalekPinpoint}");
    font-style: normal;
  }

* {
  box-sizing: border-box;
  margin: 0;
  padding: 0;
}

body {
  font-family: 'Dalek Pinpoint', sans-serif;
  font-size: 16px;
}

h1, h2, h3, h4, h5, h6, p {
  color: ${({ theme }) => theme.palette.primary.main};
  font-family: 'Dalek Pinpoint', sans-serif;
  letter-spacing: normal;
  line-height: normal;
  margin: 0;
}

p.error {
  color: ${({ theme }) => theme.palette.error.main};
}

a {
  cursor: pointer;
  font-family: 'Dalek Pinpoint', sans-serif;
  text-decoration: none;

  &:hover {
    opacity: 0.7;
  }
}

button {
  background-color: transparent;
  border: none;
  color: ${({ theme }) => theme.palette.primary.main};
  cursor: pointer;
  font-family: 'Dalek Pinpoint', sans-serif;
  outline:none;
  padding: 0;

  &:hover {
    opacity: 0.7;
  }
}

input {
  border-radius: 0;
  font-family: 'Dalek Pinpoint', sans-serif;
}

input:focus {
  outline: none;
}

textarea:focus {
  outline: none;
}
`

export default GlobalStyle
